import { connect } from "react-redux";

import Druck from "./Druck";

export default connect(state => ({
	print: state.settings.print,
	auth: state.user
}))(Druck);
